module.exports = __webpack_public_path__ + "static/img/ewm.cfff9343.webp";